var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltipCountry"},[_c('div',{staticStyle:{"vertical-align":"top","display":"inline-block","margin-top":"-5px"}},[_c('country-flag',{attrs:{"country":_vm.meeting.track.country,"size":"normal"}})],1),_c('span',{staticClass:"tooltiptextCountry"},[_vm._v(_vm._s(_vm.meeting.track.country))])])
}
var staticRenderFns = []

export { render, staticRenderFns }